import { Button } from './core';
import { Modal, ModalContent, ModalFooter, ModalHeader } from './Modal';
import { FeedbackForm } from './FeedbackForm';
import React from 'react';

export interface FeedbackModalProps {
  onClose(): void;
  isOpen: boolean;
}

export function FeedbackModal({ onClose, isOpen }: FeedbackModalProps) {
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  return (
    <Modal scrollable onClose={onClose} isOpen={isOpen}>
      <ModalHeader>I want to tell you...</ModalHeader>
      <ModalContent scrollable>
        <FeedbackForm
          onClose={onClose}
          setIsSubmitting={setIsSubmitting}
          formId="feedback-form"
        />
      </ModalContent>
      <ModalFooter>
        <Button isPending={isSubmitting} type="submit" form="feedback-form">
          Send
        </Button>
        <Button onClick={onClose}>Close</Button>
      </ModalFooter>
    </Modal>
  );
}
